











































































































import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class HelloWorld extends Vue {
  numbers: string[] = ["09005777784", "0041906001036", "0043930822500"];

  users: any[] = [];

  selectedNumbers: string[] = JSON.parse(JSON.stringify(this.numbers));
  selectedUser: any = {};

  @Watch("selectedUser")
  onUserChange() {
    this.routeTo.mobile = this.selectedUser.mobile;
  }

  routeTo = {
    mobile: ""
  };

  cnsLogin = {
    password: ""
  };
  uni = "";
  loading = false;

  currentConfig = {};

  isNumeric(num: number): boolean {
    return !isNaN(num);
  }

  getPersonForNumber(number: string): string {
    let ret = "";

    this.users.forEach(user => {
      if (user.mobile === number) {
        if (ret !== user.name) {
          ret = user.name;
        }
      }
    });

    if (!ret.length) {
      ret = "Unbekannt";
    }

    return ret;
  }

  login() {
    this.loading = true;
    this.axios
      .post(
        "https://0gn1ry4ya0.execute-api.us-east-1.amazonaws.com/login",
        this.cnsLogin
      )
      .then(response => {
        this.users = response.data.users;
        this.uni = response.data.uni;
        this.currentConfig = response.data.config;
        this.selectedUser = this.users[0];

        console.log(this.uni);
      })
      .finally(() => (this.loading = false));
  }

  refreshConfig() {
    this.loading = true;
    this.axios
      .post(
        "https://0gn1ry4ya0.execute-api.us-east-1.amazonaws.com/current-config",
        {
          uni: this.uni,
          numbers: this.numbers
        }
      )
      .then(response => {
        this.currentConfig = response.data;
      })
      .finally(() => (this.loading = false));
  }

  applyChanges() {
    this.loading = true;
    this.axios
      .post("https://0gn1ry4ya0.execute-api.us-east-1.amazonaws.com/change", {
        uni: this.uni,
        numbers: this.numbers,
        mobile: this.routeTo.mobile
      })
      .then(response => {
        if (response.data.error) {
          this.$buefy.toast.open({
            duration: 10000,
            message:
              "Die Änderungen konnten nicht bzw. nicht vollständig übernommen werden.",
            position: "is-bottom",
            type: "is-danger"
          });
        } else {
          this.$buefy.toast.open({
            duration: 5000,
            message: "Die Änderungen wurden erfolgreich übernommen.",
            position: "is-bottom",
            type: "is-success"
          });
        }

        this.refreshConfig();
      })
      .catch(() => {
        this.$buefy.toast.open({
          duration: 10000,
          message:
            "Bei der Anfrage gab es Serverprobleme. Die Änderungen wurden nicht übernommen.",
          position: "is-bottom",
          type: "is-danger"
        });
        this.loading = false;
      });
  }
}
